"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_WITH_ME_KEY = exports.TAGS_KEY = exports.CUSTOM_FIELDS_FILTER_KEY = exports.CUSTOM_FIELDS_KEY = exports.CATEGORIES_KEY = exports.STATUS_KEY = exports.ORGANIZATION_KEY = exports.TYPE_KEY = void 0;
exports.TYPE_KEY = 'assets.@type';
exports.ORGANIZATION_KEY = 'assets.AssetNode.organizationId';
exports.STATUS_KEY = 'asset-minor-versions.VersionNode.status';
exports.CATEGORIES_KEY = 'customer-metadata.CustomerMetadataNode.categories';
exports.CUSTOM_FIELDS_KEY = 'k:customer-metadata.CustomerMetadataNode.fields';
exports.CUSTOM_FIELDS_FILTER_KEY = 'CustomFieldsFilter';
exports.TAGS_KEY = 'customer-metadata.CustomerMetadataNode.tags';
exports.SHARED_WITH_ME_KEY = 'sharedWithMe';
